import { ErrorHandlerArgs } from "@/shared/types";
import * as datadog from "@/shared/datadog";
import { get as _get } from "lodash";
import Vue from "vue";
import { useNotifierStore } from "./store/notifier";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";

export function handleError (config: ErrorHandlerArgs) {

    if (typeof config.error === "string") {
        datadog.log(config.error, {}, "error");
    } else {
        datadog.log(
            _get(config, "error.message"),
            _get(config, "error", {}),
            "error");
    }

    let notificationError = "";

    if (!isNullEmptyOrUndefined(config.overrideNotificationMessage)) {
        notificationError = config.overrideNotificationMessage;
    } else {
        notificationError = config.error;
    }

    const notifierStore = useNotifierStore();
    return notifierStore.error({error: notificationError, rethrow: config.rethrow, timeout: config.timeout});
}

/* tslint:disable:no-bitwise */
export function generateUUID () {
    let d = new Date().getTime();
    const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
}

/* tslint:enable:no-bitwise */

/** Vue.set but with TypeScript to get the `key` string type help. */
export const vueSet = <
    TState extends object,
    TKey extends keyof TState & (string | number)> (
    state: TState,
    key: TKey, value: TState[TKey]) => {
    return Vue.set(state, key, value);
};

export const getStoragePaths = (storeName: string) => {
        const site = process.env.VUE_APP_PORTAL;
        let paths: [];
        if (site === "admin") {
            paths = adminStoreLocalStoragePaths[storeName];
        } else if (site === "employer") {
            paths = employerStoreLocalStoragePaths[storeName];
        }
        else {
            paths = employeeStoreLocalStoragePaths[storeName];
        }
        return paths ? paths : [];
};

const adminStoreLocalStoragePaths = {
    user: [ "user", "loggedIn", "lastActivity", "authType" ],
    loginRedirect: [ "routeObject" ],
    impersonator: [ "impersonation", "isActive", "isStarting", "initiateResponseFetchState", "impersonationInitiateData" ],
    rolePermissions: [ "fetchState", "partnerPermissions", "employerPermissions", "userPermissions" ],
    pageSize: [ "pageSize" ],
    mfa: [ "mfaStatus" ],
    role: [ "partnerRoles", "employerRoles" ]
};

const employerStoreLocalStoragePaths = {
    user: [ "user", "loggedIn", "employerId", "employers", "partnerId",
        "partners", "lastActivity", "authType",
        "accountHolderPartnerId",
        "accountHolderEmployerId",
        "employersState",
        "lastEmployerLogin"],
    wexInstanceCode: [ "wexInstanceCode" ],
    pageSize: [ "pageSize" ],
    loginRedirect: [ "routeObject" ],
    rolePermissions: [ "fetchState", "partnerPermissions", "employerPermissions", "userPermissions" ],
    impersonator: [ "impersonation", "isActive", "isStarting", "initiateResponseFetchState", "impersonationInitiateData" ],
    portalCustomization: [ "partnerId", "communicationKitType" ],
    mfa: [ "mfaStatus" ],
    payee: ["lastActivePayees"],
    role: [ "partnerRoles", "employerRoles" ],
    theme: ["colorValues", "fontFace", "colorStyle" ],
};

const employeeStoreLocalStoragePaths = {
    user: [ "user",
        "loggedIn",
        "isNotionalDashboardActive",
        "lastActivity",
        "accountType",
        "employeeFundingOption",
        "accountHolderPartnerId",
        "accountHolderEmployerId",
        "loginMethod",
        "authType" ],
    impersonator: [ "impersonation", "isActive", "isStarting", "initiateResponseFetchState", "impersonationInitiateData" ],
    wizard: [ "onboardingWizardState", "onboardingWizard", "transitionToEmployee", "stepsCompleting", "allowDrivewealthPreEnrollment" ],
    theme: [ "colorValues", "fontFace", "colorStyle" ],
    userPlan: [ "planType" ],
    custodianSettings: [ "employerCustodianSettings", "userCustodianSettings" ],
    loginRedirect: [ "routeObject" ],
    portalCustomization: [ "partnerId" ],
    saml: [ "provider" ],
    mfa: [ "mfaStatus" ],
    hsabAccounts: [ "accountDisplayTypeFetchState", "accountDisplayType" ],
    ebto: [ "campaignId", "claimUser" ],
    userFeedback: [ "shouldPrompt" ],
    devinirTransferInKind: [ "nonCompliantMessageAcknowledged" ],
    biometricsAuth: [ "hasPrompted" ],
};
